<template>
    <div>
        <header-section />
        <cards-section />
        <map-section />
        <contact-section />

    </div>

</template>
<script>
import header from '@/components/formation/template/header'
import cards from  '@/components/formation/template/cards'
import map from '@/components/formation/template/map'
import contact from '@/components/formation/form/contact'

export default {
  components: {
    'header-section' : header,
    'cards-section' : cards,
    'map-section' : map,
    'contact-section' : contact
  }
}
</script>

<style scoped lang="scss">


</style>
